import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Logout } from '../../../../redux/fetchActions/tokens';
import IconContainer from './styledComponent';

const LogoutIcon: React.ElementType = () => {
  const dispatch = useDispatch();

  return (
    <Link to="/login" style={{ textDecoration: 'none' }}>
      <IconContainer onClick={() => dispatch(Logout())}>
        <ExitToAppIcon />
        <span style={{ fontSize: '1rem' }}>sair</span>
      </IconContainer>
    </Link>
  );
};

export default LogoutIcon;
